import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2a2b4907"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["data-comment-id"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("span", { "data-comment-id": _ctx.id }, null, 8, _hoisted_1));
}
